import { Button, ButtonProps } from "@ttc3k/trekker";
import { mkConfig, generateCsv, download, ColumnHeader } from "export-to-csv";
import { useTranslation } from "react-i18next";

type CsvData = Record<string, string | number>[];

interface ExportToCSVProps {
  colHeaders: ColumnHeader[];
  data?: CsvData;
  onGetData?: () => Promise<CsvData>;
  filename: string;
  buttonProps?: ButtonProps;
  buttonCopy?: string;
}

export const ExportToCSV = ({
  colHeaders,
  data = [],
  onGetData,
  filename,
  buttonProps,
  buttonCopy,
}: ExportToCSVProps) => {
  const { t } = useTranslation();
  const csvConfig = mkConfig({
    columnHeaders: colHeaders,
    filename,
  });

  const handleDownloadCsv = async () => {
    let csvData = data;

    if (onGetData) {
      // Allow callers to pass in an asynchronous function that returns the csv
      // data. If the caller doesn't need this, they can just pass in data
      // through the data arg
      csvData = await onGetData();
    }

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  return (
    <Button w={"full"} size={"lg"} {...buttonProps} onClick={handleDownloadCsv}>
      {buttonCopy ?? t("core:EXPORT.TO_CSV")}
    </Button>
  );
};
